import angular from 'angular';
import loginWithSocial from './login-with-social/login-with-social.directive';
import authForm from './auth-form/auth-form';
import registrationSimple from './registration-simple/registration-simple.directive';
import remindPassword from './remind-password/remind-password.directive';

export default angular
  .module('cian.auth', [])
  .directive('cianAfLoginWithSocial', loginWithSocial)
  .component('cianAfAuthForm', authForm)
  .directive('cianAfRegistrationSimple', registrationSimple)
  .directive('cianAfRemindPassword', remindPassword).name;
